import { combineReducers, configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { PERSIST, REHYDRATE } from 'redux-persist';
import { gameConfigStore } from './GameConfigStore';
import { gameplayActionMiddleware } from './GameplayActionMiddleware';
import { gamePlayStore } from './GameplayStore';
import { settingsStore } from './SettingsStore';
import { createPersistor, persistedReducer } from './StorePersistence';

const rootReducer = combineReducers({
	gameConfig: gameConfigStore.reducer,
	gamePlay: gamePlayStore.reducer,
	settings: settingsStore.reducer,
});

const listenerMiddleware = createListenerMiddleware();

export const store = configureStore({
	reducer: persistedReducer(rootReducer),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [PERSIST, REHYDRATE],
			},
		})
			.prepend(listenerMiddleware.middleware)
			.concat(gameplayActionMiddleware),
});

export const storePersistor = createPersistor(store);

type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppSelect = useSelector.withTypes<RootState>();

// @see https://redux-toolkit.js.org/api/createListenerMiddleware#listener-subscription-management
export const startAppListening = listenerMiddleware.startListening.withTypes<RootState, AppDispatch>();
